export { default } from './EnergiaSolarVantagens';
